// src/common/components/cartModal/components/cutlerySelector/CutlerySelector.tsx
import React from "react";
import { MdRestaurant } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./CutlerySelector.module.scss";

interface CutlerySelectorProps {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  min?: number;
  max?: number;
  disabledBackground?: boolean;
}

export default function CutlerySelector({
  value,
  onIncrement,
  onDecrement,
  min = 0,
  max = 10,
  disabledBackground = false,
}: CutlerySelectorProps) {
  const { theme } = useTheme();

  return (
    <div
      className={styles.itemContainer}
      style={{ backgroundColor: theme.card, borderColor: theme.border }}
    >
      <div
        className={styles.itemImage}
        style={{ backgroundColor: theme.background }}
      >
        <MdRestaurant size={24} color={theme.primary} />
      </div>

      <div className={styles.itemInfo}>
        <h4 className={styles.itemName} style={{ color: theme.text }}>
          Приборы
        </h4>
        <span
          className={styles.unitPrice}
          style={{ color: theme.textSecondary }}
        >
          {value === 0 ? "Без приборов" : `${value} шт`}
        </span>
      </div>

      <div
        className={styles.quantityControls}
        style={{
          borderColor: theme.border,
          backgroundColor: disabledBackground ? theme.card : theme.background,
        }}
      >
        <button
          className={styles.quantityButton}
          onClick={onDecrement}
          disabled={value <= min}
        >
          <span style={{ color: theme.primary }}>-</span>
        </button>

        <span className={styles.quantityText} style={{ color: theme.text }}>
          {value}
        </span>

        <button
          className={styles.quantityButton}
          onClick={onIncrement}
          disabled={value >= max}
        >
          <span style={{ color: theme.success }}>+</span>
        </button>
      </div>

      <div className={styles.deletePlaceholder} />
    </div>
  );
}